import { useState } from 'react'
import CloseIcon from 'assets/svgr-icons/Close.svg'
import Icon from 'common-components/Icon'
import { useDropdownState } from 'hooks/useDropdownState'
import { ImagePreviewPopup } from 'components/ImagePreviewPopup'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import * as Styled from './styled'
import { SpinningLoader } from 'common-components'
import { COLORS } from 'consts/colors'
import { IReferenceMediaItem } from 'types/aiVideo'
import { isBlobUrl } from 'utils'

interface IFramePanelProps {
  frameData: IReferenceMediaItem
  onRemove: (id: string) => void
}

const FilledFrame: React.FC<IFramePanelProps> = ({ frameData, onRemove }) => {
  const { url, id, isLoading } = frameData || {}

  const [isImageFetching, setIsImageFetching] = useState(true)
  const isImageUploading = isLoading || isBlobUrl(url)

  const {
    isOpen: isPreviewOpen,
    closeDropdown: closePreview,
    openDropdown: openPreview
  } = useDropdownState()

  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation()
    if (id) {
      onRemove(id)
    }
  }

  return (
    <Styled.FilledPanel>
      {isImageUploading && (
        <SpinningLoader
          loaderColor={COLORS.primaryDark}
          size={32}
          className="loading-spinner"
        />
      )}
      <Styled.ImageWrapper
        $hoverText={translate(T.PREVIEW)}
        onClick={openPreview}
      >
        {url && (
          <Styled.PanelImage
            src={url}
            alt="Frame image"
            onLoad={() => setIsImageFetching(false)}
            $isLoading={isImageFetching}
          />
        )}
      </Styled.ImageWrapper>
      <Styled.RemoveIconWrapper onClick={handleRemove}>
        <Icon icon={<CloseIcon />} size="small" color="secondarySemiLight" />
      </Styled.RemoveIconWrapper>
      {isPreviewOpen && (
        <ImagePreviewPopup
          isOpen={isPreviewOpen}
          onClose={closePreview}
          url={url}
          aspectRatio="1"
        />
      )}
    </Styled.FilledPanel>
  )
}

export default FilledFrame
